import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
  className?: string;
  type?: 'button' | 'submit';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  href,
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wider pixel-corners relative overflow-hidden transition-all duration-100';
  const variants = {
    primary: 'bg-gradient-to-b from-m3-on-surface to-m3-on-surface-light text-white border-4 border-m3-on-surface shadow-[0_8px_0_0_#0D7080,0_8px_20px_0_rgba(13,112,128,0.3)] hover:shadow-[0_6px_0_0_#0D7080,0_6px_20px_0_rgba(13,112,128,0.4)] active:shadow-[0_2px_0_0_#0D7080] active:translate-y-[6px]',
    secondary: 'bg-gradient-to-b from-word-current to-word-error-light text-word-error border-4 border-m3-outline shadow-[0_8px_0_0_#45300F,0_8px_20px_0_rgba(69,48,15,0.3)] hover:shadow-[0_6px_0_0_#45300F,0_6px_20px_0_rgba(69,48,15,0.4)] active:shadow-[0_2px_0_0_#45300F] active:translate-y-[6px]',
    outline: 'bg-white text-m3-on-surface border-4 border-m3-on-surface shadow-[0_0_20px_rgba(13,112,128,0.2)] hover:bg-m3-on-surface hover:text-white hover:shadow-[0_0_30px_rgba(13,112,128,0.3)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-11">{children}</span>
      <motion.div className="absolute inset-0 bg-white opacity-0" whileHover={{
      opacity: 0.1
    }} transition={{
      duration: 0.2
    }} data-id="element-12" />
    </>;
  if (href) {
    return <motion.a href={href} className={classes} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-13">
        {content}
      </motion.a>;
  }
  return <motion.button type={type} onClick={onClick} className={classes} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-14">
      {content}
    </motion.button>;
}